import { UnsavedChangesDialog } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/UnsavedChangesDialog';
import { Sheet, SheetContent } from '@e2n/ui/v2';
import type { AnyFormApi } from '@tanstack/react-form';
import { useState } from 'react';
import { Navigate, Outlet, useNavigate, useParams } from 'react-router-dom';

export interface SheetOutletContext {
  registerForm: (form: AnyFormApi | null) => void;
}

export function SheetWrapper() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<AnyFormApi | null>(null);
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] =
    useState(false);

  if (!id) {
    return <Navigate to="/mitarbeiter/rotationsplaene" replace />;
  }

  const hasUnsavedChanges = () =>
    form
      ? Object.values(form.state.fieldMeta).some(
          (field) => !field?.isDefaultValue,
        )
      : false;

  return (
    <>
      <Sheet
        open
        onOpenChange={(open) => {
          if (!open) {
            if (hasUnsavedChanges()) {
              setShowUnsavedChangesDialog(true);
            } else {
              navigate(`/mitarbeiter/rotationsplan/${id}`, { replace: true });
            }
          }
        }}>
        <SheetContent className="md:min-w-120">
          <Outlet
            context={{ registerForm: setForm } satisfies SheetOutletContext}
          />
        </SheetContent>
      </Sheet>

      <UnsavedChangesDialog
        open={showUnsavedChangesDialog}
        onCancel={() => setShowUnsavedChangesDialog(false)}
        onConfirm={() => {
          form?.reset();
          setShowUnsavedChangesDialog(false);
          navigate(`/mitarbeiter/rotationsplan/${id}`, { replace: true });
        }}
      />
    </>
  );
}
